import { Button, CircularProgress, Stack, SxProps } from '@mui/material';

type Props = {
  buttonIcon?: React.ReactNode;
  buttonLabel: string;
  cancelButtonLabel: string;
  loading?: boolean;
  loadingLabel?: string;
  onCancel: () => void;
  sx?: SxProps;
  saveButtonStyles?: SxProps;
  cancelButtonStyles?: SxProps;
  cancelButtonDisabled?: boolean;
  saveButtonDisabled?: boolean;
};

export const SaveCancelFormButtons = ({
  buttonIcon,
  buttonLabel,
  cancelButtonLabel,
  loading,
  loadingLabel,
  onCancel,
  sx,
  cancelButtonStyles,
  saveButtonStyles,
  cancelButtonDisabled,
  saveButtonDisabled,
}: Props) => {
  return (
    <Stack direction="row" sx={sx}>
      <Button
        sx={{ borderRadius: '4px', ...cancelButtonStyles }}
        onClick={onCancel}
        disabled={loading || cancelButtonDisabled}
      >
        {cancelButtonLabel}
      </Button>
      <Button
        disabled={saveButtonDisabled || loading}
        type="submit"
        variant="contained"
        sx={{ ...saveButtonStyles }}
        startIcon={loading ? <></> : buttonIcon}
      >
        {loading ? (
          <>
            {loadingLabel} <CircularProgress color="secondary" size={20} />
          </>
        ) : (
          buttonLabel
        )}
      </Button>
    </Stack>
  );
};
